import { useMemo } from 'react'
import { useFormContext } from 'react-hook-form'
import { OrderStatuses } from '../../../types/common'

export const useOrderStatus = () => {
  const { watch } = useFormContext()

  const status = watch('status')

  const isNotDrafted = useMemo(() => {
    return status !== OrderStatuses.Draft && status !== undefined && status !== null
  }, [status])

  const isCreated = useMemo(() => {
    return status === OrderStatuses.Created
  }, [status])

  const isDrafted = useMemo(() => {
    return status === OrderStatuses.Draft
  }, [status])

  const isEdit = useMemo(() => {
    const id = watch('id')
    return !!id
  }, [watch])

  return {
    status,
    isNotDrafted,
    isCreated,
    isDrafted,
    isEdit,
  }
}
